'use strict';
import React from 'react';
import Section from "./Section";
import logoAnb from '../../images/Sponsorlogo Natuur en bos.png';
import logoAwv from '../../images/Sponsorlogo Wegen en verkeer.png';

const InSamenWerkingMetLogos = () => {
    return (
        <Section>
            <div style={{ backgroundColor: '#f4f4f4', color: '#777', fontSize: '14px', padding: '10px' }}>
                <div>In samenwerking met :</div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', marginTop: '10px' }}>
                    <img style={{ height: '40px', width: '95px' }} src={logoAnb} alt="Agentschap Natuur en Bos" title="Agentschap Natuur en Bos" />
                    <img style={{ height: '40px', width: '95px' }} src={logoAwv} alt="Agentschap Wegen en Verkeer" title="Agentschap Wegen en Verkeer" />
                </div>
            </div>
        </Section>);
};

export default InSamenWerkingMetLogos;